import React from "react";
import {ColumnsType} from "antd/es/table";
import {SuccessSVG} from "assets";
import "./PatientList.scss";
import {ColumnProps} from "types/models";
import moment from "moment";
import {FORMAT_TIME} from "types/enums";
import {birthday2Age, convertDateStringToDateTimezone_7} from "helper/common";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
import {formatPhoneNumber} from "helper/format-phone";
import PatientTypeColumn from "components/common/ColumnColors/KCBTypeColumn/PatientTypeColumn";
import {loaiBNOptions} from "assets/constants/kbnt-category";

const columnsTablePatientList: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "4%",
    render: (text, record, index) => index + 1,
    align: "center",
    show: true,
    isResizable: true,
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    key: "maBenhNhan",
    // width: '8%',
    align: "left",
    show: true,
    isResizable: true,
  },
  {
    title: "Mã PK",
    dataIndex: "idPhieuKham",
    key: "idPhieuKham",
    // width: '8%',
    align: "left",
    show: true,
    isResizable: true,
  },
  {
    title: "Mã PCĐ",
    dataIndex: "maPhieuChiDinh",
    key: "maPhieuChiDinh",
    align: "center",
    show: true,
    isResizable: true,
  },
  {
    title: "Tên BN",
    dataIndex: "tenBenhNhan",
    key: "tenBenhNhan",
    // width: '10%',
    align: "left",
    show: true,
    isResizable: true,
    disabledCheck: true,
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    // width: '6%',
    align: "left",
    render: gioiTinh => {
      if (gioiTinh == 0) return <span>Nam</span>;
      else if (gioiTinh == 1) return <span>Nữ</span>;
    },
    show: true,
    isResizable: true,
    disabledCheck: true,
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    key: "ngaySinh",
    align: "center",
    show: true,
    isResizable: true,
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",
  },
  {
    title: "Tuổi",
    dataIndex: "age",
    key: "age",
    align: "center",
    render: (text, record: {ngaySinh: Date}) =>
      record.ngaySinh ? birthday2Age(record.ngaySinh) : "",
    show: true,
    isResizable: true,
    disabledCheck: true,
  },
  {
    title: "Ngày tạo",
    dataIndex: "ngayTao",
    key: "ngayTao",
    align: "center",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return (
        <div>{value ? moment(value).format(FORMAT_TIME.dateTime) : null}</div>
      );
    },
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    key: "diaChi",
    // width: '10%',
    align: "left",
    show: true,
    isResizable: true,
  },
  {
    title: "SĐT",
    dataIndex: "dienThoai",
    key: "dienThoai",
    // width: '10%',
    align: "right",
    show: true,
    isResizable: true,
    disabledCheck: true,
    render: v => formatPhoneNumber(v),
  },
  {
    title: "Loại KCB",
    dataIndex: "loaiKhamChuaBenh",
    key: "loaiKhamChuaBenh",
    // width: '8%',
    align: "left",
    show: true,
    isResizable: true,
    // render: (loaiKhamChuaBenh) => {
    //   if (loaiKhamChuaBenh == 0) return <div>Thông thường</div>;
    //   if (loaiKhamChuaBenh == 1) return <div>Cấp cứu</div>;
    //   if (loaiKhamChuaBenh == 2) return <div>Tái khám thông thường</div>;
    //   if (loaiKhamChuaBenh == 3) return <div>Tái khám sau phẫu thuật</div>;
    //   if (loaiKhamChuaBenh == 4) return <div>Hẹn phẫu thuật</div>;
    //   if (loaiKhamChuaBenh == 5) return <div>Khám đo kính</div>;
    //   if (loaiKhamChuaBenh == 6) return <div>Định kỳ</div>;
    //   if (loaiKhamChuaBenh == 7) return <div>Khác</div>;
    // },
    disabledCheck: true,
  },
  {
    title: "Loại bệnh nhân",
    dataIndex: "loaiBenhNhans",
    key: "loaiBenhNhans",
    show: true,
    isResizable: true,
    // disabledCheck: true,
    width: 130,
    align: "center",
    render: (v, r, i) => {
      let ten = v ? loaiBNOptions.find(it => it.value === v[0])?.label : "";
      return <PatientTypeColumn label={ten} />;
    },
    // isResizable: true
  },
  {
    title: "BS chỉ định",
    dataIndex: "bacSiChiDinh",
    key: "bacSiChiDinh",
    // width: '10%',
    align: "left",
    show: true,
    isResizable: true,
    disabledCheck: true,
  },
  {
    title: "Trạng thái XN",
    dataIndex: "trangThaiXetNghiem",
    key: "trangThaiXetNghiem",
    // width: '15%',
    align: "center",
    render: text => {
      let textTT;
      if (text == 0) {
        textTT = "Phiếu Khám Mới";
      } else if (text == 1) {
        textTT = "Chờ Thực Hiện";
      } else if (text == 2) {
        textTT = "Đang Thực Hiện";
      } else if (text == 3) {
        textTT = "Hoàn Thành";
      } else if (text == 4) {
        textTT = "Chờ kết quả xét nghiệm";
      } else if (text == 5) {
        textTT = "Đã có kết quả xét nghiệm";
      } else if (text == 6) {
        textTT = "Hủy thực hiện";
      } else if (text == 7) {
        textTT = "Đã xóa";
      }
      return <KCBStatusColumn label={textTT}></KCBStatusColumn>;
    },
    show: true,
    isResizable: true,
    disabledCheck: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    // width: '10%',
    align: "center",
    show: true,
    isResizable: true,
  },
];

export {columnsTablePatientList};
